module.exports = __webpack_public_path__ + "static/img/phone-AR.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-AR.png
// module id = I/Zh
// module chunks = 1